<script lang="ts">import Link from '../../../shared/Link/Link.svelte';
import SubcategoryLinkList from '../Lists/SubcategoryLinkList.svelte';
import ImageListCategory from '../../../shared/ImageListCategory/ImageListCategory.svelte';
import { MAX_COLUMN_WIDTH, TIMEOUT_ENTER_DURATION, TIMEOUT_LEAVE_DURATION } from '../../../../../js-v2/constants';
import { getComponentType } from '../../../../../js-v2/componentUtils';
import { activeDropdownStore } from '../../../../../js-v2/stores/desktop-nav-stores';
import { hoverWithDelay } from '../../../../../js-v2/hoverWithDelay';
import { getTracking } from '../../../../../js-v2/tracking';
import { getCategory, getLocation, getNavDeviceType } from '../../../../../js-v2/trackingUtils';
import { getUrlPath } from '../../../../../js-v2/urlUtils';
const { navItem } = $props();
let gridEl = $state();
let gridWidth = $state(0);
let activeItemId = $state(null);
const gridRowsCount = (navItem.props.primaryNavItems?.length || 0) + (navItem.props.secondaryNavItems ? 1 : 0);
const trackFn = getTracking();
function handleMouseOver(item) {
    if ($activeDropdownStore.subcategoryId !== item.contentfulEntryId) {
        trackFn({
            eventName: 'Open Menu',
            properties: {
                currentPage: getUrlPath(),
                menuId: item.contentfulEntryId,
                menuText: item.props.title,
                menuCategory: getCategory(gridEl),
                menuSubcategory: item.props.title,
                menuLocation: getLocation(gridEl),
                navDeviceType: getNavDeviceType(gridEl),
            },
        });
    }
    if ($activeDropdownStore.subcategoryId !== item.contentfulEntryId) {
        activeDropdownStore.openSubcategory(item.contentfulEntryId);
    }
}
$effect(() => {
    if ($activeDropdownStore.id && $activeDropdownStore.id !== navItem.contentfulEntryId)
        activeItemId = null; // Clear activeItemId when switch active tab
    if (!$activeDropdownStore.contentHeight)
        activeItemId = null; // Clear activeItemId when dropdown closed
});
function handleKeyDown(event, item) {
    if (event.key === 'Enter') {
        if ($activeDropdownStore.subcategoryId !== item.contentfulEntryId) {
            trackFn({
                eventName: 'Open Menu',
                properties: {
                    currentPage: getUrlPath(),
                    menuId: item.contentfulEntryId,
                    menuText: item.props.title,
                    menuCategory: getCategory(gridEl),
                    menuSubcategory: item.props.title,
                    menuLocation: getLocation(gridEl),
                    navDeviceType: getNavDeviceType(gridEl),
                },
            });
        }
        $activeDropdownStore.subcategoryId === item.contentfulEntryId
            ? activeDropdownStore.closeSubcategory()
            : activeDropdownStore.openSubcategory(item.contentfulEntryId);
    }
}
</script>

<div
  bind:this={gridEl}
  class="NavigationCategoryGrid"
  class:max-column-width={gridWidth * 0.33 > MAX_COLUMN_WIDTH}
  style:--subcategory-row-end={`${gridRowsCount + 1}`}
  style:--grid-rows-count={gridRowsCount - 1}
  bind:offsetWidth={gridWidth}
>
  <!-- This key block is needed to fix the bug where animation not re-triggered in Safari. It forces Safari to re-mount this block whenever the dropdown is reopened after window resize. -->
  {#key gridWidth}
    {#if navItem.props.primaryNavItems?.length}
      {#each navItem.props.primaryNavItems as item, index}
        <div class="trigger-col">
          <div
            class:slide-in-target={$activeDropdownStore.showSlideInAnimation}
            style:--slide-in-item-index={index + 1}
          >
            <button
              class="toggle"
              class:inactive={activeItemId && activeItemId !== item.contentfulEntryId}
              aria-haspopup="true"
              aria-expanded={$activeDropdownStore.subcategoryId === item.contentfulEntryId}
              aria-controls={`global-nav-desktop-subcategory-col-${item.contentfulEntryId}`}
              data-entry-id={item.contentfulEntryId}
              use:hoverWithDelay={[
                () => {
                  handleMouseOver(item);
                  activeItemId = item.contentfulEntryId;
                },
                () => {},
                TIMEOUT_ENTER_DURATION,
                TIMEOUT_LEAVE_DURATION,
              ]}
              onkeydown={(event) => handleKeyDown(event, item)}
            >
              <span>{item.props.title}</span>
            </button>
          </div>
        </div>

        <div
          id="global-nav-desktop-subcategory-col-{item.contentfulEntryId}"
          class="subcategory-col"
          class:active={$activeDropdownStore.subcategoryId === item.contentfulEntryId}
          data-subcategory={item.props.title}
        >
          {#if getComponentType(item?.componentName) === 'imageListCategory'}
            <ImageListCategory id={item.contentfulEntryId} title={item.props.title} navItems={item.props.navItems} />
          {:else if getComponentType(item?.componentName) === 'category'}
            <SubcategoryLinkList subcategory={item} />
          {/if}
        </div>
      {/each}
    {/if}

    <div class="secondary-links-list" class:has-primary-nav-items={!!navItem.props.primaryNavItems?.length}>
      <ul class="secondary-dropdown-nav-item-list">
        {#if navItem.props?.secondaryNavItems?.length}
          {#each navItem.props.secondaryNavItems as link, index}
            <li
              class:slide-in-target={$activeDropdownStore.showSlideInAnimation}
              class:inactive={activeItemId && activeItemId !== link.contentfulEntryId}
              style:--slide-in-item-index={(navItem.props.primaryNavItems?.length || 0) + index + 1}
            >
              <Link
                linkCustomCssClass="subcategory-small-link"
                id={link.contentfulEntryId}
                title={link.props.title}
                url={link.props.url}
                linkStyle={link.props.linkStyle}
                openInNewTab={link.props.openInNewTab}
                hoverWithDelayConfig={[
                  () => {
                    activeDropdownStore.closeSubcategory();
                    activeItemId = link.contentfulEntryId;
                  },
                  () => {},
                  TIMEOUT_ENTER_DURATION,
                  TIMEOUT_LEAVE_DURATION,
                ]}
              />
            </li>
          {/each}
        {/if}
      </ul>
    </div>
  {/key}
</div>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.NavigationCategoryGrid {
  display: grid;
  width: 100%;
  grid-auto-rows: min-content;
  grid-template-rows: repeat(var(--grid-rows-count), auto) 1fr;
  grid-template-columns: 33% 1fr;
  grid-column-gap: 20px;
}
.NavigationCategoryGrid.max-column-width {
  grid-template-columns: 350px 1fr;
}

.slide-in-target {
  opacity: 0;
  animation: fade-in-slide-from-top 300ms ease-in forwards;
  animation-delay: calc(150ms + var(--slide-in-item-index) * 20ms);
}

ul {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
}
ul > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
ul > li::before {
  display: none;
}
ul > li :global(:last-child) {
  margin: 0;
}

li {
  transition: opacity 250ms;
}
li.inactive {
  opacity: 43% !important;
}

.toggle {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, var(--color-neutral-000, #000000));
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  --letter-spacing: var(--text-variant-200-letter-spacing);
  --line-height: var(--text-variant-200-line-height);
  --font-size: var(--text-variant-200-font-size);
  --font-weight: var(--text-variant-200-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-200-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  padding: 5px 0px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: opacity 250ms;
}
.toggle:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.toggle:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.toggle:focus {
  background: transparent;
  outline: none;
}
.toggle:hover {
  background: transparent;
}
.toggle.inactive {
  opacity: 43% !important;
}

.trigger-col {
  grid-column-start: 1;
}

.subcategory-col {
  grid-row: 1/var(--subcategory-row-end);
  grid-column-start: 2;
  display: none;
}
.subcategory-col.active {
  display: block;
}

.secondary-links-list {
  grid-column-start: 1;
}
.secondary-links-list.has-primary-nav-items {
  padding-top: 20px;
}
.secondary-links-list .secondary-dropdown-nav-item-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}</style>
